import { useEffect, useState } from 'react';
import AdminLayout from '../../components/AdminLayout';
import { api } from '../../lib/api';
import type { Source, SourceType } from '../../types';

const SOURCE_TYPES: SourceType[] = [
  'rss', 'ical', 'instagram', 'eventbrite', 'meetup', 'bandsintown', 'email', 'manual', 'venue'
];

export default function AdminSourcesPage() {
  const [sources, setSources] = useState<Source[]>([]);
  const [type, setType] = useState<SourceType>('rss');
  const [name, setName] = useState('');
  const [url, setUrl] = useState('');

  const load = () => api.get<Source[]>('/api/mgmt/sources').then(setSources);
  useEffect(() => { void load(); }, []);

  const add = async (e: React.FormEvent) => {
    e.preventDefault();
    await api.post('/api/mgmt/sources', { type, name, url, enabled: true });
    setName(''); setUrl(''); void load();
  };

  const toggle = async (s: Source) => {
    await api.patch(`/api/mgmt/sources/${s.partitionKey}/${s.rowKey}`, { enabled: !s.enabled });
    void load();
  };

  return (
    <AdminLayout>
      <h1>Sources</h1>
      <form className="row g-2 align-items-end mb-4" onSubmit={add}>
        <div className="col-md-3">
          <label htmlFor="src-type" className="form-label">Type</label>
          <select id="src-type" className="form-select" value={type} onChange={(e) => setType(e.target.value as SourceType)}>
            {SOURCE_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
        </div>
        <div className="col-md-4">
          <label htmlFor="src-name" className="form-label">Name</label>
          <input id="src-name" className="form-control" required value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <div className="col-md-4">
          <label htmlFor="src-url" className="form-label">URL / handle</label>
          <input id="src-url" className="form-control" value={url} onChange={(e) => setUrl(e.target.value)} />
        </div>
        <div className="col-md-1">
          <button type="submit" className="btn btn-primary w-100">Add</button>
        </div>
      </form>

      <table className="table">
        <thead>
          <tr><th scope="col">Type</th><th scope="col">Name</th><th scope="col">URL</th><th scope="col">Last fetch</th><th scope="col">Enabled</th></tr>
        </thead>
        <tbody>
          {sources.map((s) => (
            <tr key={`${s.partitionKey}|${s.rowKey}`}>
              <td>{s.partitionKey}</td>
              <td>{s.name}</td>
              <td className="text-truncate" style={{ maxWidth: 300 }}>{s.url}</td>
              <td className="small">{s.lastFetchedAt ? new Date(s.lastFetchedAt).toLocaleString() : '—'}</td>
              <td>
                <button className={`btn btn-sm ${s.enabled ? 'btn-success' : 'btn-outline-secondary'}`} onClick={() => toggle(s)}>
                  {s.enabled ? 'On' : 'Off'}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </AdminLayout>
  );
}
